export class ResetProjectUsersList {
  public static readonly type =
    '[Project/ProjectMember/List] ResetProjectUsersList';
}
